import BaseResource from '@/app-core/lib/data/resource/BaseResource'

export default class RegisterResource extends BaseResource {
  constructor(payload = {}) {
    super(payload)

    this.Firstname = payload.Firstname ?? ''
    this.Lastname = payload.Lastname ?? ''
    this.Email = payload.Email ?? ''
    this.Phone = payload.Phone ?? ''
    this.PhonePrefix = payload.PhonePrefix ?? ''
    this.PhoneValidated = payload.PhoneValidated ?? false
    this.EmailValidated = payload.EmailValidated ?? false
    this.Password = payload.Password ?? ''
    this.PasswordConfirm = payload.PasswordConfirm ?? ''
    this.TermsCondition = payload.TermsCondition ?? null
    this.MarketingConsent = payload.MarketingConsent ?? null
    this.FromSocialProvider = !!payload.SocialProvider
  }

  /* PROPERTIES */

  /* METHODS */
}
